class ListUtils {
    /**
     * @param {string[]} list 
     */
    static toHtmlClasses(list) {
        return list.filter(s => s !== "").join(" ");
    }

    /**
     * Just your basic Fisher-Yates, modifies the passed list
     * @param {any[]} list 
     */
    static shuffleInPlace(list) {
        for (let i = list.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i+1));

            const tmp = list[i];
            list[i] = list[randomIndex];
            list[randomIndex] = tmp;
        }
    }
}

export default ListUtils;